import { render, staticRenderFns } from "./NewsShow.vue?vue&type=template&id=3443b220&scoped=true&"
import script from "./NewsShow.vue?vue&type=script&lang=js&"
export * from "./NewsShow.vue?vue&type=script&lang=js&"
import style0 from "./NewsShow.vue?vue&type=style&index=0&id=3443b220&lang=scss&scoped=true&"
import style1 from "./NewsShow.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3443b220",
  null
  
)

export default component.exports